/*
=================================================================================
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
=================================================================================

  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 PRO React layouts

// @mui icons
import Icon from "@mui/material/Icon";

// Images
import Dashboard from "layouts/dashboard/Dashboard";
import Logout from "layouts/authen/Logout";
import User from "layouts/user/User";
import Sales from "layouts/dashboards/sales";
import Role from "layouts/role/Role";
import Category from "layouts/product/Category";
import Invoice from "layouts/invoice/Invoice";
import Menus from "layouts/menu/Menus";
import MainMenu from "layouts/menu/MainMenu";
import Company from "layouts/company/Company";
import Customer from "layouts/customer/Customer";
import Quotation from "layouts/quotation/Quotation";
import Unit from "layouts/product/Unit";
import Product from "layouts/product/Product";
import RawMaterial from "layouts/product/RawMaterial";
import PurchaseRequest from "layouts/purchaserequest/PurchaseRequest";
import PurchaseOrder from "layouts/purchaseorder/PurchaseOrder";
import PointOfSale from "layouts/pos/PointOfSale";
import Receive from "layouts/receive/Receive";
import PurchasePay from "layouts/purchase_pay/PurchasePay";
import ExportStore from "layouts/export_store/ExportStore";
import ImportStore from "layouts/import_store/ImportStore";
import RequestRawmat from "layouts/request_rawmat/RequestRawmat";
import PickupRawmat from "layouts/pickup_rawmat/PickupRawmat";
import JobOrder from "layouts/job_order/JobOrder";
import ProductionFinish from "layouts/production_finish/ProductionFinish";
import SaleOrder from "layouts/sale_order/SaleOrder";
import Car from "layouts/car/Car";
import NotifyGroup from "layouts/notify/NotifyGroup";
import Notify from "layouts/notify/Notify";
import PermissionType from "layouts/permission/PermissionType";
import Permission from "layouts/permission/Permission";
import Bank from "layouts/bank/Bank";
import Province from "layouts/setting/Province";
import District from "layouts/setting/District";
import SubDistrict from "layouts/setting/SubDistrict";
import Warehouse from "layouts/setting/Warehouse";
import Zone from "layouts/setting/Zone";
import BankAccount from "layouts/bank/BankAccount";
import LineNotify from "layouts/notify/LineNotify";
import LineToken from "layouts/notify/LineToken";
import RpStock from "layouts/report_stock/RpStock";
import RpStockBranch from "layouts/report_stock_branch/RpStockBranch";
import Supplier from "layouts/supplier/Supplier";
import PurchaseType from "layouts/purchaseorder/PurchaseType";
import PayoutType from "layouts/payout/PayoutType";
import Payout from "layouts/payout/Payout";
import Shipping from "layouts/shipping/Shipping";
import Log from "layouts/tool/Log";
import AdjustStock from "layouts/adjust_stock/AdjustStock";
import DashboardAdmin from "layouts/dashboard/DashboardAdmin";
import DashboardSale from "layouts/dashboard/DashboardSale";
import Branch from "layouts/branch/Branch";
import Account from "layouts/account/Account";
import AccountType from "layouts/account/AccountType";
import Creditor from "layouts/creditor/Creditor";
import Debtor from "layouts/debtor/Debtor";
import Receipt from "layouts/receipt/Receipt";
import PurchasePr from "layouts/purchase_pr/PurchasePr";
import ReceiveStore from "layouts/receive_store/ReceiveStore";
import PickupStore from "layouts/pickup_store/PickupStore";
import ReceiveType from "layouts/receive_store/ReceiveType";
import PickupType from "layouts/pickup_store/PickupType";
import Message from "layouts/profile/Message";
import Saleman from "layouts/saleman/Saleman";
import Meeting from "layouts/saleman/Meeting";
import Task from "layouts/task/Task";

const routes = [
  {
    type: "collapse",
    name: "",
    key: "avatar",
    icon: null,
    collapse: [
      {
        name: "menu.profile",
        key: "profile",
        route: "/profile",
        component: <User />,
      },
      {
        name: "menu.changepassword",
        key: "changepassword",
        route: "/changepassword",
        component: <Role />,
      },
      {
        name: "menu.message",
        key: "message",
        route: "/message",
        component: <Message />,
      },
      {
        name: "menu.logout",
        key: "logout",
        route: "/logout",
        component: <Logout />,
      },
    ],
  },
  { type: "divider", key: "divider-0" },
  {
    type: "collapse",
    name: "menu.dashboard",
    key: "dashboard_menu",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    collapse: [
      {
        name: "menu.dashboard_admin",
        key: "dashboard_admin",
        route: "/dashboard_admin",
        component: <DashboardAdmin />,
      },
      {
        name: "menu.dashboard_sale",
        key: "dashboard_sale",
        route: "/dashboard_sale",
        component: <DashboardSale />,
      },
      {
        name: "menu.dashboard_production",
        key: "dashboard_production",
        route: "/dashboard_production",
        component: <DashboardSale />,
      },
      {
        name: "menu.dashboard_purchase",
        key: "dashboard_purchase",
        route: "/dashboard_purchase",
        component: <DashboardSale />,
      },
      {
        name: "menu.dashboard_account",
        key: "dashboard_account",
        route: "/dashboard_account",
        component: <DashboardSale />,
      },
      {
        name: "menu.dashboard_stock",
        key: "dashboard_stock",
        route: "/dashboard_stock",
        component: <DashboardSale />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.sale",
    key: "sale_menu",
    icon: <Icon fontSize="medium">monetization_on</Icon>,
    collapse: [
      {
        name: "menu.pos",
        key: "pos",
        route: "/pos",
        component: <PointOfSale />,
      },
      {
        name: "menu.sale_order",
        key: "sale_order",
        route: "/sale_order",
        component: <SaleOrder />,
      },
      {
        name: "menu.quotation",
        key: "quotation",
        route: "/quotation",
        component: <Quotation />,
      },
      {
        name: "menu.invoice",
        key: "invoice",
        route: "/invoice",
        component: <Invoice />,
      },
      {
        name: "menu.receipt",
        key: "receipt",
        route: "/receipt",
        component: <Receipt />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.purchase",
    key: "purchase_menu",
    icon: <Icon fontSize="medium">shopping_basket</Icon>,
    collapse: [
      {
        name: "menu.purchase_request",
        key: "purchase_request",
        route: "/purchase_request",
        component: <PurchaseRequest />,
      },
      {
        name: "menu.purchase_pr",
        key: "purchase_pr",
        route: "/purchase_pr",
        component: <PurchasePr />,
      },
      {
        name: "menu.purchase_order",
        key: "purchase_order",
        route: "/purchase_order",
        component: <PurchaseOrder />,
      },
      {
        name: "menu.supplier",
        key: "supplier",
        route: "/supplier",
        component: <Supplier />,
      },
      {
        name: "menu.purchase_type",
        key: "purchase_type",
        route: "/purchase_type",
        component: <PurchaseType />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.warehouse",
    key: "warehouse_menu",
    icon: <Icon fontSize="medium">store</Icon>,
    collapse: [
      {
        name: "menu.receive",
        key: "receive",
        route: "/receive",
        component: <Receive />,
      },
      {
        name: "menu.export_store",
        key: "export_store",
        route: "/export_store",
        component: <ExportStore />,
      },
      {
        name: "menu.import_store",
        key: "import_store",
        route: "/import_store",
        component: <ImportStore />,
      },
      {
        name: "menu.receive_store",
        key: "receive_store",
        route: "/receive_store",
        component: <ReceiveStore />,
      },
      {
        name: "menu.pickup_store",
        key: "pickup_store",
        route: "/pickup_store",
        component: <PickupStore />,
      },
      {
        name: "menu.pickup_rawmat",
        key: "pickup_rawmat",
        route: "/pickup_rawmat",
        component: <PickupRawmat />,
      },
      {
        name: "menu.receive_type",
        key: "receive_type",
        route: "/receive_type",
        component: <ReceiveType />,
      },
      {
        name: "menu.pickup_type",
        key: "pickup_type",
        route: "/pickup_type",
        component: <PickupType />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.production",
    key: "production_menu",
    icon: <Icon fontSize="medium">foundation</Icon>,
    collapse: [
      {
        name: "menu.job_order",
        key: "job_order",
        route: "/job_order",
        component: <JobOrder />,
      },
      {
        name: "menu.production_finish",
        key: "production_finish",
        route: "/production_finish",
        component: <ProductionFinish />,
      },
      {
        name: "menu.request_rawmat",
        key: "request_rawmat",
        route: "/request_rawmat",
        component: <RequestRawmat />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.shipping",
    key: "shipping_menu",
    icon: <Icon fontSize="medium">local_shipping</Icon>,
    collapse: [
      {
        name: "menu.shipping",
        key: "shipping",
        route: "/shipping",
        component: <Shipping />,
      },
      {
        name: "menu.car",
        key: "car",
        route: "/car",
        component: <Car />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.account",
    key: "account_menu",
    icon: <Icon fontSize="medium">request_quote</Icon>,
    collapse: [
      {
        name: "menu.purchase_pay",
        key: "purchase_pay",
        route: "/purchase_pay",
        component: <PurchasePay />,
      },
      {
        name: "menu.creditor",
        key: "creditor",
        route: "/creditor",
        component: <Creditor />,
      },
      {
        name: "menu.debtor",
        key: "debtor",
        route: "/debtor",
        component: <Debtor />,
      },
      {
        name: "menu.adjust_stock",
        key: "adjust_stock",
        route: "/adjust_stock",
        component: <AdjustStock />,
      },
      {
        name: "menu.payout",
        key: "payout",
        route: "/payout",
        component: <Payout />,
      },
      {
        name: "menu.payout_type",
        key: "payout_type",
        route: "/payout_type",
        component: <PayoutType />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.customer",
    key: "customer_menu",
    icon: <Icon fontSize="medium">groups</Icon>,
    collapse: [
      {
        name: "menu.customer",
        key: "customer",
        route: "/customer",
        component: <Customer />,
      },
      {
        name: "menu.saleman",
        key: "saleman",
        route: "/saleman",
        component: <Saleman />,
      },
      {
        name: "menu.task",
        key: "task",
        route: "/task",
        component: <Task />,
      },
      {
        name: "menu.meeting",
        key: "meeting",
        route: "/meeting",
        component: <Meeting />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.product",
    key: "product_menu",
    icon: <Icon fontSize="medium">settings_input_composite</Icon>,
    collapse: [
      {
        name: "menu.product",
        key: "product",
        route: "/product",
        component: <Product />,
      },
      {
        name: "menu.rawmaterial",
        key: "rawmaterial",
        route: "/rawmaterial",
        component: <RawMaterial />,
      },
      {
        name: "menu.promotion",
        key: "promotion",
        route: "/promotion",
        component: <Dashboard />,
      },
      {
        name: "menu.category",
        key: "category",
        route: "/category",
        component: <Category />,
      },
      {
        name: "menu.unit",
        key: "unit",
        route: "/unit",
        component: <Unit />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.report",
    key: "report_menu",
    icon: <Icon fontSize="medium">content_paste</Icon>,
    collapse: [
      {
        name: "menu.rp_sale",
        key: "rp_sale",
        route: "/rp_sale",
        component: <RpStock />,
      },
      {
        name: "menu.rp_stock",
        key: "rp_stock",
        route: "/rp_stock",
        component: <RpStock />,
      },
      {
        name: "menu.rp_stock_branch",
        key: "rp_stock_branch",
        route: "/rp_stock_branch",
        component: <RpStockBranch />,
      },
      {
        name: "menu.rp_product_supplier",
        key: "rp_product_supplier",
        route: "/rp_product_supplier",
        component: <RpStockBranch />,
      },
      {
        name: "menu.rp_payout",
        key: "rp_payout",
        route: "/rp_payout",
        component: <RpStockBranch />,
      },
      {
        name: "menu.rp_purchase",
        key: "rp_purchase",
        route: "/rp_purchase",
        component: <RpStockBranch />,
      },
      {
        name: "menu.rp_stock_product",
        key: "rp_stock_product",
        route: "/rp_stock_product",
        component: <RpStockBranch />,
      },
      {
        name: "menu.rp_profit",
        key: "rp_profit",
        route: "/rp_profit",
        component: <RpStockBranch />,
      },
      {
        name: "menu.rp_production",
        key: "rp_production",
        route: "/rp_production",
        component: <RpStockBranch />,
      },
      {
        name: "menu.rp_shipping",
        key: "rp_shipping",
        route: "/rp_shipping",
        component: <RpStockBranch />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.user",
    key: "user_menu",
    icon: <Icon fontSize="medium">people</Icon>,
    collapse: [
      {
        name: "menu.user",
        key: "user",
        route: "/user",
        component: <User />,
      },
      {
        name: "menu.role",
        key: "role",
        route: "/role",
        component: <Role />,
      },
      {
        name: "menu.line_notify",
        key: "line_notify",
        route: "/line_notify",
        component: <LineNotify />,
      },
      {
        name: "menu.line_token",
        key: "line_token",
        route: "/line_token",
        component: <LineToken />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.setting",
    key: "setting_menu",
    icon: <Icon fontSize="medium">settings</Icon>,
    collapse: [
      {
        name: "menu.company",
        key: "company",
        route: "/company",
        component: <Company />,
      },
      {
        name: "menu.setting",
        key: "setting",
        route: "/setting",
        component: <Dashboard />,
      },
      {
        name: "menu.branch",
        key: "branch",
        route: "/branch",
        component: <Branch />,
      },
      {
        name: "menu.warehouse",
        key: "warehouse",
        route: "/warehouse",
        component: <Warehouse />,
      },
      {
        name: "menu.zone",
        key: "zone",
        route: "/zone",
        component: <Zone />,
      },
      {
        name: "menu.bank_account",
        key: "bank_account",
        route: "/bank_account",
        component: <BankAccount />,
      },
      {
        name: "menu.account",
        key: "account",
        route: "/account",
        component: <Account />,
      },
      {
        name: "menu.account_type",
        key: "account_type",
        route: "/account_type",
        component: <AccountType />,
      },
      {
        name: "menu.province",
        key: "province",
        route: "/province",
        component: <Province />,
      },
      {
        name: "menu.district",
        key: "district",
        route: "/district",
        component: <District />,
      },
      {
        name: "menu.subdistrict",
        key: "subdistrict",
        route: "/subdistrict",
        component: <SubDistrict />,
      },
    ],
  },
  {
    type: "collapse",
    name: "menu.tool",
    key: "tool_menu",
    icon: <Icon fontSize="medium">admin_panel_settings</Icon>,
    collapse: [
      {
        name: "menu.menu",
        key: "menu",
        route: "/menu",
        component: <Menus />,
      },
      {
        name: "menu.mainmenu",
        key: "mainmenu",
        route: "/mainmenu",
        component: <MainMenu />,
      },
      {
        name: "menu.permission",
        key: "permission",
        route: "/permission",
        component: <Permission />,
      },
      {
        name: "menu.permission_type",
        key: "permission_type",
        route: "/permission_type",
        component: <PermissionType />,
      },
      {
        name: "menu.notify",
        key: "notify",
        route: "/notify",
        component: <Notify />,
      },
      {
        name: "menu.notify_group",
        key: "notify_group",
        route: "/notify_group",
        component: <NotifyGroup />,
      },
      {
        name: "menu.bank",
        key: "bank",
        route: "/bank",
        component: <Bank />,
      },
      {
        name: "menu.log",
        key: "log",
        route: "/log",
        component: <Log />,
      },
    ],
  },
];

export default routes;
